import {createAction, props} from '@ngrx/store';
import {MarkerNgrx} from '~model/ngrx/marker-ngrx';
import {PolygonNgrx} from '~model/ngrx/polygon-ngrx';

export enum MapActionsTypes {
  SetUpdateMap = '[Map] setUpdateMap',
  SetMarkers = '[Map] setMarkers',
  SetPolygons = '[Map] setPolygons',
  SetDetails = '[Map] setDetails',
  SetSelectedGroups = '[Map] setSelectedGroups',
  UpdateSelectedGroups = '[Map] updateSelectedGroups',
  Clear = '[Map] clear'
}

export const setUpdateMap = createAction(MapActionsTypes.SetUpdateMap, props<{ resizeMap: boolean }>());
export const setMarkers = createAction(MapActionsTypes.SetMarkers, props<{ markers: MarkerNgrx[], clear?: boolean}>());
export const setPolygons = createAction(MapActionsTypes.SetPolygons, props<{ polygons: PolygonNgrx[], clear?: boolean }>());
export const mapSetDetails = createAction(MapActionsTypes.SetDetails, props<{ layer: string, item: string }>());
export const mapSetSelectedGroups = createAction(MapActionsTypes.SetSelectedGroups, props<{ selected: string }>());
export const mapUpdateSelectedGroups = createAction(MapActionsTypes.UpdateSelectedGroups, props<{ selected: string }>());
export const mapClear = createAction(MapActionsTypes.Clear);

